import React from "react";
import { Alert, Box, CheckboxField, RadioField, Typography } from "@curves/ui-base";
import { Grid } from "@mui/material";
import { SignBox } from "@icoach/components";
import { FieldGroup } from "@icoach/documents/components/Layout";
import { convertBooleanToOptionArray, getErrorModuleStatus } from "@util/utils";
import { useMembershipQuitFormContext } from "@icoach/documents/membership/quit/MembershipQuitFormContext";

const MembershipQuitNoticeSection104 = ({ hasDeviceOrder, deviceConfirmRef }) => {
	const { formData, formRef, validationErrors, updateField, isReadOnly } = useMembershipQuitFormContext();

	return (
		<Grid item xs={12}>
			<FieldGroup label="注意事項">
				<Grid item xs={12}>
					<Alert severity="info" variant="filled" color="info" className="alert-justify-content-start">
						為保障個人權益，完成以上所有條款 / 流程，方視為會員權終止手續之完成，同時我們將在會籍終止日後清除您的付款資訊，若日後需要重新加入需要再重新提供。
					</Alert>
				</Grid>
				<Grid item xs={12}>
					<Alert severity="success" variant="filled" color="success" className="alert-justify-content-start">
						謝謝您這段時間選擇 Curves 陪伴運動，相信您了解持續運動帶給您的好處，期待您會將運動帶進生活， Curves 祝福您。
					</Alert>
				</Grid>

				<Grid item xs={12}>
					{hasDeviceOrder ? (
						<CheckboxField ref={deviceConfirmRef} readOnly={isReadOnly} required>
							<CheckboxField.Checkbox
								label={
									<Box>
										<Typography>本人已瞭解並同意在會籍終止後，同步終止智能系統訂閱，並停止其相關使用權限。</Typography>
										<Typography>1. 會員如於當月15日(含)前提出終止申請，得申請當月份系統使用費之50%(新台幣125元)退款。</Typography>
										<Typography>2. 退款依公司指定線上申請辦理程序。</Typography>
									</Box>
								}
								value={1}
							/>
						</CheckboxField>
					) : null}
					<CheckboxField
						ref={el => (formRef.current.isConfirm = el)}
						key={convertBooleanToOptionArray(formData?.isConfirm)}
						defaultValue={convertBooleanToOptionArray(formData?.isConfirm)}
						onChange={e => updateField("isConfirm", e.target.checked)}
						fullWidth
						{...getErrorModuleStatus(validationErrors, "isConfirm")}
						readOnly={isReadOnly}
						required
					>
						<CheckboxField.Checkbox label="本人已瞭解、詳讀會員權終止條款，並同意遵守。" value={1} />
					</CheckboxField>
				</Grid>
				<Grid item xs={12}>
					<Typography>我們希望持續提供健康與優惠資訊，無論您是否續約，都能獲得實用內容，幫助維持良好生活品質與健康狀態。您同意繼續接收相關通知嗎？</Typography>
					<RadioField
						ref={el => (formRef.current.isAgreeSMS = el)}
						key={convertBooleanToOptionArray(formData?.isAgreeSMS)}
						defaultValue={convertBooleanToOptionArray(formData?.isAgreeSMS)}
						onChange={e => updateField("isAgreeSMS", e.target.value)}
						{...getErrorModuleStatus(validationErrors, "isAgreeSMS")}
						readOnly={isReadOnly}
						required
						row
					>
						<RadioField.Radio label="同意" value={1} />
						<RadioField.Radio label="不同意" value={2} />
					</RadioField>
					<Typography>後續您也可以隨時向我們申請停止接收通知。</Typography>
				</Grid>
				<Grid item xs={6}>
					<SignBox
						title="會員簽名"
						ref={el => (formRef.current.signImg = el)}
						key={formData?.signImg}
						{...getErrorModuleStatus(validationErrors, "signImg")}
						readOnly={isReadOnly}
						required
					/>
				</Grid>
			</FieldGroup>
		</Grid>
	);
};

export default MembershipQuitNoticeSection104;
